export default __webpack_public_path__ + "static/media/Q_wdt_c_cap_2.c9f1165d.mp3";